export { UIGamePlayerInformationCards } from './UIGamePlayerInformationCards.tsx';
